var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "relative-position layout-padding" }, [
    _c(
      "div",
      { staticClass: "text-center q-pb-lg" },
      [
        _c("h6", [_vm._v("Please select any roles this user may have:")]),
        _c("transition", { attrs: { name: "bounce" } }, [
          _vm.invalidUserRoles
            ? _c(
                "p",
                {
                  staticClass: "text-red",
                  staticStyle: { "margin-top": "20px" }
                },
                [
                  _c("q-icon", {
                    attrs: { name: "info outline", color: "red", size: "20px" }
                  }),
                  _vm._v(" Must choose at least "),
                  _c("b", [_vm._v("one")]),
                  _vm._v(" role. ")
                ],
                1
              )
            : _vm._e()
        ])
      ],
      1
    ),
    _c(
      "div",
      { staticClass: "center" },
      [
        _c(
          "q-list",
          {
            staticClass: "round",
            staticStyle: { padding: "0" },
            attrs: { link: "" }
          },
          [
            _vm.$p(["ADMIN", "MANAGER", "AFFILIATE"], "or")
              ? _c(
                  "q-item",
                  { attrs: { tag: "label", separator: "" } },
                  [
                    _c(
                      "q-item-side",
                      [
                        _c("q-icon", {
                          attrs: {
                            size: "30px",
                            color: "primary",
                            name: "fa fa-graduation-cap"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "q-item-main",
                      [
                        _c("q-item-tile", { attrs: { title: "" } }, [
                          _vm._v("Instructor")
                        ])
                      ],
                      1
                    ),
                    _c(
                      "q-item-side",
                      [
                        _c(
                          "q-field",
                          [
                            _c("q-checkbox", {
                              attrs: { value: _vm.isInstructor },
                              on: {
                                input: function(value) {
                                  _vm.updateInstructorForm({
                                    field: "ACTIVE_IND",
                                    value: value
                                  })
                                  _vm.setForm(value)
                                }
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              : _vm._e(),
            _vm.$p(["ADMIN", "MANAGER", "RECRUITER"], "or")
              ? _c(
                  "q-item",
                  { attrs: { tag: "label", separator: "" } },
                  [
                    _c(
                      "q-item-side",
                      [
                        _c("q-icon", {
                          attrs: {
                            size: "30px",
                            color: "primary",
                            name: "fa fa-building"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "q-item-main",
                      [
                        _c("q-item-tile", { attrs: { title: "" } }, [
                          _vm._v("\n            Affiliate \n            "),
                          _vm.isRecruiter
                            ? _c(
                                "span",
                                {
                                  staticClass: "text-primary",
                                  staticStyle: {
                                    "margin-left": "5px",
                                    "font-size": "14px"
                                  }
                                },
                                [
                                  _c("q-icon", { attrs: { name: "info" } }),
                                  _vm._v(" Required if also Recruiter")
                                ],
                                1
                              )
                            : _vm._e()
                        ])
                      ],
                      1
                    ),
                    _c(
                      "q-item-side",
                      [
                        _c("q-checkbox", {
                          attrs: {
                            disable: _vm.isRecruiter,
                            value: _vm.isAffiliate
                          },
                          on: {
                            input: function(value) {
                              _vm.updateAffiliateForm({
                                field: "ACTIVE_IND",
                                value: value
                              })
                              _vm.setForm(value)
                            }
                          }
                        })
                      ],
                      1
                    )
                  ],
                  1
                )
              : _vm._e(),
            _vm.$p(["ADMIN", "MANAGER"], "or")
              ? _c(
                  "q-item",
                  { attrs: { tag: "label", separator: "" } },
                  [
                    _c(
                      "q-item-side",
                      [
                        _c("q-icon", {
                          attrs: {
                            size: "30px",
                            color: "primary",
                            name: "fa fa-user-plus"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "q-item-main",
                      [
                        _c("q-item-tile", { attrs: { title: "" } }, [
                          _vm._v("Recruiter")
                        ])
                      ],
                      1
                    ),
                    _c(
                      "q-item-side",
                      [
                        _c("q-checkbox", {
                          attrs: { value: _vm.isRecruiter },
                          on: {
                            input: function(value) {
                              _vm.updateRecruiterForm({
                                field: "ACTIVE_IND",
                                value: value
                              })
                              _vm.updateAffiliateForm({
                                field: "ACTIVE_IND",
                                value: value
                              })
                              _vm.setForm(value)
                            }
                          }
                        })
                      ],
                      1
                    )
                  ],
                  1
                )
              : _vm._e(),
            _vm.$p(["ADMIN"])
              ? _c(
                  "q-item",
                  { attrs: { tag: "label", separator: "" } },
                  [
                    _c(
                      "q-item-side",
                      [
                        _c("q-icon", {
                          attrs: {
                            size: "30px",
                            color: "primary",
                            name: "fa fa-users"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "q-item-main",
                      [
                        _c("q-item-tile", { attrs: { title: "" } }, [
                          _vm._v("Manager")
                        ])
                      ],
                      1
                    ),
                    _c(
                      "q-item-side",
                      [
                        _c("q-checkbox", {
                          attrs: { value: _vm.isManager },
                          on: {
                            input: function(value) {
                              _vm.updateManagerForm({
                                field: "ACTIVE_IND",
                                value: value
                              })
                              _vm.setForm(value)
                            }
                          }
                        })
                      ],
                      1
                    )
                  ],
                  1
                )
              : _vm._e(),
            _vm.$p(["ADMIN"])
              ? _c(
                  "q-item",
                  { attrs: { tag: "label", separator: "" } },
                  [
                    _c(
                      "q-item-side",
                      [
                        _c("q-icon", {
                          attrs: {
                            size: "30px",
                            color: "primary",
                            name: "fa fa-magic"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "q-item-main",
                      [
                        _c("q-item-tile", { attrs: { title: "" } }, [
                          _vm._v("Administrator")
                        ]),
                        _c("q-item-tile", { attrs: { sublabel: "" } }, [
                          _vm._v("This user has access to everything.")
                        ])
                      ],
                      1
                    ),
                    _c(
                      "q-item-side",
                      [
                        _c("q-checkbox", {
                          attrs: { value: _vm.isAdministrator },
                          on: {
                            input: function(value) {
                              _vm.updateAdministratorForm({
                                field: "ACTIVE_IND",
                                value: value
                              })
                              _vm.setForm(value)
                            }
                          }
                        })
                      ],
                      1
                    )
                  ],
                  1
                )
              : _vm._e()
          ],
          1
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }